import { App } from '@ps20-frontend/frontend-models';

const DYNATRACE_WINDOW_ATTRIBUTE = 'dtrum';

export class Dynatrace {
  public static dtraceIdentifyUser(corrId: string): void {
    Dynatrace.callDynatraceIfAvailable('identifyUser', corrId);
  }

  public static dtraceEndSession(): void {
    Dynatrace.callDynatraceIfAvailable('endSession');
  }

  public static dtReportError(error: Error, sourceApp: App): void {
    if (
      (window as unknown as Record<string, unknown>)[DYNATRACE_WINDOW_ATTRIBUTE] &&
      typeof ((window as unknown as Record<string, unknown>)[DYNATRACE_WINDOW_ATTRIBUTE] as Record<string, unknown>)['reportError'] === 'function'
    ) {
      try {
        error.message = `${sourceApp}: ${error.message}`;
      } catch {
        return ((window as unknown as Record<string, unknown>)[DYNATRACE_WINDOW_ATTRIBUTE] as Record<string, (...a: unknown[]) => unknown>)['reportError'](error) as unknown as void;
      }
      return ((window as unknown as Record<string, unknown>)[DYNATRACE_WINDOW_ATTRIBUTE] as Record<string, (...a: unknown[]) => unknown>)['reportError'](error) as unknown as void;
    }
  }

  public static callDynatraceIfAvailable(fnName: string, ...args: unknown[]): string {
    if (
      (window as unknown as Record<string, unknown>)[DYNATRACE_WINDOW_ATTRIBUTE] &&
      typeof ((window as unknown as Record<string, unknown>)[DYNATRACE_WINDOW_ATTRIBUTE] as Record<string, unknown>)[fnName] === 'function'
    ) {
      return ((window as unknown as Record<string, unknown>)[DYNATRACE_WINDOW_ATTRIBUTE] as Record<string, (...a: unknown[]) => unknown>)[fnName](args) as string;
    }
    return null;
  }
}
